import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';

const EMOJI = {
  'web-scraping': '🕷️',
  scraping: '🕷️',
  'sneaker-bots': '👟',
  sneakers: '👟',
  'social-media': '📱',
  'residential-proxies': '🏠',
  'datacenter-proxies': '🏢',
  'seo-monitoring': '📈',
  'price-monitoring': '💲',
  'ad-verification': '✅',
  'market-research': '📊',
  gaming: '🎮',
  streaming: '📺',
  ticketing: '🎟️',
};

export default class ProxyviewsBestForIndexRoute extends DiscourseRoute {
  async model() {
    const data = await ajax('/best-for.json');
    const useCases = (data.use_cases || []).map((uc) => ({
      slug: uc,
      label: uc
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' '),
      emoji: EMOJI[uc] || '🔹',
      url: `/best-for/${uc}`,
    }));
    return { useCases };
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.set('model', model);
  }

  titleToken() {
    return 'Best Proxies By Use Case';
  }
}
